<script>
  import {mapMutations, mapState} from 'vuex';
  import helpers from '@/helpers';
  import PostingProcessingPrototype from '@/prototypes/PostingProcessingPrototype';

  export default {
    extends: PostingProcessingPrototype,
    data() {
      return {
        radiosItemName: 'severalSuppliersProcessing',
        description: ''
      };
    },
    computed: {
      ...mapState('PostingStore/ProcessRequirementStore', {
        processing: ({severalSuppliersProcessing}) => severalSuppliersProcessing,
        processingErrors: ({errors}) => errors.severalSuppliersProcessing.errors
      }),
      choices() {
        return [{
          text: helpers.getJobInfo.jobProcessRequirement(this, 'several_suppliers_auto_update'),
          value: 'several_suppliers_auto_update'
        }, {
          text: helpers.getJobInfo.jobProcessRequirement(this, 'several_suppliers_cancel_not_found'),
          value: 'several_suppliers_cancel_not_found'
        }];
      }
    },
    methods: {
      ...mapMutations('PostingStore/ProcessRequirementStore', ['setSeveralSuppliersProcessing']),
      catchProcessing(value) {
        this.removeOneError({
          storeName: 'PostingStore',
          subStoreName: 'ProcessRequirementStore',
          fieldName: 'severalSuppliersProcessing'
        });
        this.setSeveralSuppliersProcessing(value);
      }
    }
  };
</script>
